// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/grade.css
// module id = 2588
// module chunks = 2